import * as types from 'actions/action-types';

var initialState = {
    error_log_save_pending: false,

    messages: [],
	messages_pending: false,
	messages_save_pending: false,
	messages_unsubscribe: false,
};

const adminReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.ERROR_LOG + '_SAVE_PENDING': save_pending('error_log'); break;
        case types.ERROR_LOG + '_SAVE_FULFILLED': save_fulfilled('error_log'); break;

        case types.MESSAGES + '_PENDING': pending('messages'); break;
		case types.MESSAGES + '_FULFILLED': fulfilled('messages'); break;
		case types.MESSAGES + '_SAVE_PENDING': save_pending('messages'); break;
		case types.MESSAGES + '_SAVE_FULFILLED': save_fulfilled('messages'); break;
		case types.MESSAGES + '_CLEAR': state = { ...state, messages: [] }; break;

        default: break;
    }

    return state;

    function pending(table) {
		state = {
			...state,
			[table + '_pending']: true,
		};
	}
	function save_pending(table) {
		state = {
			...state,
			[table + '_save_pending']: true,
		};
	}
	function save_fulfilled(table) {
		state = {
			...state,
			[table + '_save_pending']: false,
		};
	}
	function fulfilled(table) {
		state = {
			...state,
			[table]: action.data,
			[table + '_pending']: false,
			[table + '_save_pending']: false,
			[table + '_unsubscribe']: (action.unsubscribe) ? action.unsubscribe : state[table + '_unsubscribe'],
		};
	}

};
export default adminReducer;


